import { keyframes } from 'styled-components';

export const fillAnswerPercentage = p => {
    return keyframes`
    from { 
      width: 0%;
    }
    to {
      width: ${p}%; 
    }
  `;
};



// WEBPACK FOOTER //
// ./src/containers/Poll/PollAnimations.jsx